import { render, staticRenderFns } from "./SavedPhrases.vue?vue&type=template&id=34ba5a04&"
import script from "./SavedPhrases.vue?vue&type=script&lang=js&"
export * from "./SavedPhrases.vue?vue&type=script&lang=js&"
import style0 from "./SavedPhrases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports